import React from 'react';
import '../styles/App.css';

const FilterSection = ({ filters, onFilterChange, onReset, onSearch }) => {
  return (
    <div className="filter-section">
      <div className="filter-row">
        <div className="filter-group">
          <label className="filter-label">Date & Time</label>
          <select 
            className="filter-input"
            value={filters.dateRange}
            onChange={(e) => onFilterChange('dateRange', e.target.value)}
          >
             <option default>Select Date</option>
            <option>Last 7 Days</option>
            <option>Last 30 Days</option>
            <option>Custom Date</option>
          </select>
        </div>

        <div className="filter-group">
          <label className="filter-label">Call Type</label>
          <select 
            className="filter-input"
            value={filters.callType}
            onChange={(e) => onFilterChange('callType', e.target.value)}
          >
            <option value="">All</option>
            <option value="OUTGOING">Outgoing</option>
            <option value="INCOMING">Incoming</option>
          </select>
        </div>

        <div className="filter-group">
          <label className="filter-label">Call Status</label>
          <select 
            className="filter-input"
            value={filters.statusCode}
            onChange={(e) => onFilterChange('statusCode', e.target.value)}
          >
            <option value="">All</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
            <option value="busy">Busy</option>
            <option value="canceled">Canceled</option>
            <option value="no_answer">No Answer</option>
            <option value="rejected">Rejected</option>
            <option value="initiated">Initiated</option>
          </select>
        </div>
      </div>

      <div className="filter-row">
        <div className="filter-group">
          <label className="filter-label">Caller Number</label>
          <input 
            type="text"
            className="filter-input"
            value={filters.username}
            onChange={(e) => onFilterChange('username', e.target.value)}
            placeholder="Enter caller number"
          />
        </div>

        <div className="filter-group">
          <label className="filter-label">Receiver Number</label>
          <input 
            type="text"
            className="filter-input"
            value={filters.receiver || ''}
            onChange={(e) => onFilterChange('receiver', e.target.value)}
            placeholder="Enter receiver number"
          />
        </div>

        <div className="filter-group">
          {filters.dateRange === 'Custom Date' && (
            <>
              <label className="filter-label">Start Date &amp; End Date (end defaults to today)</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="date"
                  className="filter-input"
                  value={filters.start_date || ''}
                  max={filters.end_date || undefined}
                  onChange={(e) => onFilterChange('start_date', e.target.value)}
                />
                <input
                  type="date"
                  className="filter-input"
                  value={filters.end_date || ''}
                  min={filters.start_date || undefined}
                  onChange={(e) => onFilterChange('end_date', e.target.value)}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <div className="filter-actions">
        <button className="reset-button" onClick={onReset}>
          Reset
        </button>
        <button className="search-button" onClick={onSearch}>
          Search
        </button>
      </div>
    </div>
  );
};

export default FilterSection;